import { render, staticRenderFns } from "./TableMobileRawMaterialsComponent.vue?vue&type=template&id=20540f87&scoped=true&"
import script from "./TableMobileRawMaterialsComponent.vue?vue&type=script&lang=js&"
export * from "./TableMobileRawMaterialsComponent.vue?vue&type=script&lang=js&"
import style0 from "./TableMobileRawMaterialsComponent.vue?vue&type=style&index=0&id=20540f87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20540f87",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCheckbox,VContainer,VDivider,VProgressLinear})
